export const isEmpty = (value: unknown) =>
  value === undefined || value === null || value === '';

export const isNumberString = (value: unknown): value is string =>
  typeof value === 'string' && !isNaN(Number(value));
